export const rules = function () {
  return{
    //只能填写数字
    onlyNumber:function (rule,value,callback) {
      var reg = /^\d+$|^\d*\.\d+$/g;
        if(!reg.test(value)){
          return callback(new Error('只能输入数字及小数点后两位'))
        }else {
          callback()
        }
    },

    /**
     * 英文字符校验
     */
    enText(rule, value, callback) {
      if (value && !(/^[A-Za-z]+$/).test(value)) {
        callback(new Error('只能填写英文字符'))
      } else {
        callback()
      }
    },
    /**
     * 只能输入英文或者数字
     */
    enOrnunText (rule, value, callback) {
      if (value && !(/^[A-Za-z0-9]+$/).test(value)) {
        callback(new Error('只能填写英文或者数字'))
      } else {
        callback()
      }
    },
    //手机号码校验
    phoneNumber(rule, value, callback) {
      if (value && (!(/^1[3456789]\d{9}$/.test(value)) || value.length !== 11)) {
        callback(new Error('手机号码不符合规范'))
      } else {
        callback()
      }
    },
    //身份证号码校验
    idCard(rule, value, callback) {
      if (value && (!(/\d{17}[\d|x]|\d{15}/).test(value) || (value.length !== 15 && value.length !== 18))) {
        callback(new Error('身份证号码不符合规范'))
      } else {
        callback()
      }
    },
    // 姓名的验证规则
    Email: function (rule, value, callback) {
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      if (!email.test(value)) {
        callback(new Error('请输入正确的邮箱!'))
      } else {
        callback()
      }
    },
    // 身份证的验证规则
    ID: function (rule, value, callback) {
      if (!value) {
        return callback(new Error('身份证不能为空'))
      }
      if (!regId.test(value)) {
        callback(new Error('请输入正确的二代身份证号码'))
      } else {
        callback()
      }
    },
    // 电话号码的验证
    Tel: (rule, value, callback) => {
      if (!value) {
        return callback(new Error('电话不能为空'))
      }
      if (!tel.test(value)) {
        callback(new Error('请正确填写电话号码'))
      } else {
        callback()
      }
    },
  }
}
export default {
  rules
}




// WEBPACK FOOTER //
// ./src/api/validate.js